import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import {Item} from "@/types/Component"
import Modal from '@/assets/common/Modal/Modal.vue'
import draggable from 'vuedraggable'
import {isItem, isItemList} from "@/types/guards"
import ApiClient from "@/assets/common/api-client/api-client"
import { toCamel, toSnake } from 'snake-camel';
import store from '@/assets/common/store/store';


type ResponseItem = {
    id: string;
    name: string;
    is_hidden: boolean
}

@Component({
    components: {
        Modal,
        draggable
    }
})
export default class MaterialSelectModal extends Vue {

    @Prop({default: () => "/materials"})
    apiPath!: string;

    @Prop({default: () => []})
    options!: string[];

    @Prop({default: () => true})
    multiple!: boolean
    
    @Prop({required: false})
    private initialValue!: Item[] | Item | null

    @Prop() 
    isShowMaterialSelectModal!: boolean

    @Prop({default: () => true})
    filterable!: boolean
    filter: string | null = null

    @Prop({default: () => false})
    sortable!: boolean

    @Prop({default: () => false})
    required!: boolean

    selectedValue: Item | Item[] | null = []
    candidates: Item[] = []
    isLoading = false // TODO: Implement loader spinner

    addCandidateModalVisible = false

    @Watch("isShowMaterialSelectModal")
    onOpen(newValue: boolean) {
        this.isLoading = true
        if (!newValue) {
            return
        }
        this.filter = null
        this.fetchCandidates().then(items => {
            this.candidates = items
            this.selectedValue = this.multiple ? [] : null
            
            if (this.multiple && isItemList(this.initialValue)) {
                this.selectedValue = this.initialValue.map(item => {
                    const search = this.candidates.find(candidateItem => candidateItem.id === item.id)
                    return search
                }).filter(search => !!search) as Item[]
            } else if (!this.multiple && isItem(this.initialValue)) {
                const initialValue = this.initialValue as Item
                this.selectedValue = this.candidates.find(candidate => candidate.id === initialValue.id)!
            }
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    closeModal(){
        this.$emit('update:isShowMaterialSelectModal', false);
    }

    private sortName(a: any, b: any): number {
        if (!a.name && !b.name) return 0; 
        if (!a.name) return 1;            
        if (!b.name) return -1;
    
        const nameA = a.name;
        const nameB = b.name;
    
        const isLatinA = /^[\u0020-\u007E]+$/.test(nameA); 
        const isLatinB = /^[\u0020-\u007E]+$/.test(nameB);
    
        if (isLatinA && !isLatinB) return -1; 
        if (!isLatinA && isLatinB) return 1;  
    
        for (let i = 0; i < Math.min(nameA.length, nameB.length); i++) {
            if (nameA[i] < nameB[i]) return -1; 
            if (nameA[i] > nameB[i]) return 1;
        }
    
        return nameA.length - nameB.length;
    }
    

    disabledCheck(id: string): boolean {
        if(this.multiple && isItemList(this.initialValue)) {
            const item = this.initialValue.find(v => v.id === id)
            return item?.disabledCheck !== undefined && item.disabledCheck
        }
        else if(!this.multiple && isItem(this.initialValue)) {
            return this.initialValue.id === id && this.initialValue.disabledCheck !== undefined && this.initialValue.disabledCheck
        }
        return false
    }

    get filteredCandidates(): Item[] {
        if (this.filter === null) {
            return this.candidates
        }
        const filteredCandidate = this.candidates.filter(item => item.name.indexOf(this.filter!) >= 0)

        return filteredCandidate;
    }

    async fetchCandidates(): Promise<Item[]> {
        const optionsPath = this.options.length === 0 ? '' : this.options.reduce((pre, cur) => `${pre}${cur}&`, '?').slice(0, -1);
        
        const response = await this.$apiClient.doRequest('get', `${this.apiPath}${optionsPath}`);
        
        const lastSegment = this.apiPath.split('/').pop();
        if (!lastSegment) {
            throw new Error("Invalid API path: unable to determine last segment.");
        }
       const responseData = response[lastSegment];
        
        return responseData.map((res: ResponseItem) => toCamel(res) as Item);
    }
    

    selectItem(item: Item) {
        if (!this.multiple) {
            this.selectedValue = item
        } else {
            const selectedValue = this.selectedValue as Item[]
            const idx = selectedValue.indexOf(item)
            if (idx === -1) {
                selectedValue.push(item)
            } else {
                selectedValue.splice(idx, 1)
            }
        }
    }

    @Emit()
    close() {
        this.inputChanged();
        this.closeModal();
        return this.selectedValue
    }

    @Emit()
    cancel() {
        this.closeModal();
    }


    get isValid() {
        return true
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
            this.$store.dispatch('doUpdateIsInputChanged', true);
            }
    }

    private selectCheckAll() {
        this.selectedValue = this.candidates
    }

    private clearCheckAll(){
        this.selectedValue=[]
    }
         
}      